import { useLEAccordionItemContext } from '../../../components/LEAccordion/LEAccordionItem/useLEAccordionItem';
import VerifyNumberPanel from '../../../components/marketplace/phoneVerify/VerifyNumberPanel';
import { useTemporaryInfoUpdateMutation } from '../../../gql/generated/graphql';
import { useTempInfo } from '../../../hooks';

// Pre-deal verify gate. The seller is a temporary-info record, so no dealId is
// passed and consent keys to the temp-info record, traveling to the deal at import.
// The verified number is persisted to temp info so a revisit shows the done state.
const SellDetailsVerifyNumberItem = () => {
  const { isExpanded } = useLEAccordionItemContext();
  const { info, infoLoading, refetch } = useTempInfo({
    fetchPolicy: 'network-only',
    refresh: isExpanded,
  });
  const [updateTemporaryInfo] = useTemporaryInfoUpdateMutation();

  const phoneNumber = info?.data?.phone_number;
  if (infoLoading || !info || !phoneNumber) return null;

  const handleVerified = async () => {
    await updateTemporaryInfo({
      variables: { info: { id: info.id, data: { verified_phone_number: phoneNumber } } },
    });
    refetch();
  };

  return (
    <VerifyNumberPanel
      phoneNumber={phoneNumber}
      verifiedNumber={info?.data?.verified_phone_number ?? undefined}
      onVerified={handleVerified}
    />
  );
};

export default SellDetailsVerifyNumberItem;
